function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9 9.40002C14.1 9.40002 13.4 10.1 13.4 10.9V13.8H10.5C9.7 13.8 9 14.5 9 15.3C9 16.1 9.7 16.8 10.5 16.8H13.4V19.7C13.4 20.5 14.1 21.2 14.9 21.2C15.7 21.2 16.4 20.5 16.4 19.7V16.8H19.3C20.1 16.8 20.8 16.1 20.8 15.3C20.8 14.5 20.1 13.8 19.3 13.8H16.4V10.9C16.3 10.1 15.7 9.40002 14.9 9.40002Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7 26C23.7 25.2 23 24.5 22.2 24.5H9.5C8.7 24.5 8 25.2 8 26C8 26.8 8.7 27.5 9.5 27.5H22.2C23 27.5 23.7 26.9 23.7 26Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 29C8.7 29 8 29.7 8 30.5C8 31.3 8.7 32 9.5 32H20.3C21.1 32 21.8 31.3 21.8 30.5C21.8 29.7 21.1 29 20.3 29H9.5Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5996 16.1C29.428 16.1 30.0996 15.4284 30.0996 14.6C30.0996 13.7715 29.428 13.1 28.5996 13.1C27.7712 13.1 27.0996 13.7715 27.0996 14.6C27.0996 15.4284 27.7712 16.1 28.5996 16.1Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30 5.1C30 2.3 27.7 0 24.9 0H5.4C2.4 0 0 2.4 0 5.4V32.6C0 35.6 2.4 38 5.4 38H24.6C27.6 38 30 35.6 30 32.6V20.6V20.5C30 20.4 30 20.3 30 20.3C30 19.5 29.3 18.8 28.5 18.8C27.7 18.8 27 19.5 27 20.3C27 20.3 27 20.3 27 20.4C27 20.5 26.9 20.6 26.9 20.7V32.7C26.9 34 25.8 35.1 24.5 35.1H5.4C4.1 35.1 3 34 3 32.7V5.4C3 4.1 4.1 3 5.4 3H24.9C26.1 3 27 4 27 5.1V8.8C27 8.9 27 9 27.1 9.1C27.2 9.8 27.8 10.3 28.5 10.3C29.3 10.3 30 9.6 30 8.8V5.1Z"
});

function SvgContractAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 38,
    viewBox: "0 0 31 38",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractAdd);
export default __webpack_public_path__ + "static/media/contractAdd.3bd8cc6a.svg";
export { ForwardRef as ReactComponent };